
export function pickUpInternalVariable(internalVariables, pointer){
  return internalVariables[pointer];
}


export function findItemFromUpwardInfo(findWhat, info){
  for (var i = 0; i < info.length; i++){
    if (info[i].t === findWhat){
      return info[i].v;
    }
  }
  return null;
}


export function findItemFromUpwardInfoNew(t, path, info){
  for (var i = 0; i < info.length; i++){
    if (info[i].t === t && info[i].p.join(' ') === path.join(' ')){
      return info[i].v;
    }
  }
  return null;
}

